(() => {
  if (window.PPColorGallery) return;
  window.PPColorGallery = {
    update(info, html) {
      const gallery = info.querySelector('media-gallery[data-pp-color]');
      const next = html.querySelector('media-gallery[data-pp-color]');
      if (!gallery || !next) return false;
      const currentIdentifiers = info.querySelector('[id^="PPIdentifiers-"]');
      const nextIdentifiers = html.querySelector('[id^="PPIdentifiers-"]');
      if (currentIdentifiers && nextIdentifiers) currentIdentifiers.replaceWith(nextIdentifiers.cloneNode(true));
      if (gallery.dataset.ppColor === next.dataset.ppColor) return true;
      window.pauseAllMedia?.();
      const replacement = next.cloneNode(true);
      replacement.querySelectorAll('.scroll-trigger').forEach(node => node.classList.add('scroll-trigger--cancel'));
      gallery.replaceWith(replacement);
      const modal = info.productModal?.querySelector('.product-media-modal__content');
      const nextModal = html.querySelector('product-modal .product-media-modal__content');
      if (modal && nextModal) modal.innerHTML = nextModal.innerHTML;
      requestAnimationFrame(() => {
        if (!replacement.isConnected) return;
        replacement.querySelectorAll('slider-component').forEach(slider => {
          slider.resetPages?.();
          slider.slider?.scrollTo({ left: 0, behavior: 'instant' });
        });
        const firstMedia = replacement.querySelector('[data-media-id]');
        if (firstMedia) replacement.setActiveMedia?.(firstMedia.dataset.mediaId, false);
        if (info.hasAttribute('data-zoom-on-hover') && typeof enableZoomOnHover === 'function') enableZoomOnHover(2);
      });
      return true;
    }
  };
  document.addEventListener('change', event => {
    const group = event.target.closest('.pp-color-options');
    if (!group) return;
    group.querySelectorAll('input[type="radio"]').forEach(input => input.setAttribute('aria-checked', String(input.checked)));
  });
  window.addEventListener('popstate', () => {
    const info = document.querySelector('product-info[id^="MainProduct-"]');
    if (!info?.querySelector('media-gallery[data-pp-color]')) return;
    const id = new URL(location.href).searchParams.get('variant');
    const selected = info.querySelector('script[data-selected-variant]');
    const current = selected ? JSON.parse(selected.textContent)?.id : null;
    if (String(current ?? '') === String(id ?? '')) return;
    const url = new URL(location.href);
    url.searchParams.set('section_id', info.dataset.section);
    info.renderProductInfo({ requestUrl: url.toString(), targetId: '', callback: info.handleUpdateProductInfo(info.dataset.url) });
  });
})();
